const model = require('/opt/build/repo/src/model').model
module.exports = model.createStore({"initState":{"loadingUser":false},"initLocal":{"user":null},"localFixture":{"user":null}})
